import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';
import sagas from './sagas';
import { setStore } from './store-registry';

export function configureStore() {
    const sagaMiddleware = createSagaMiddleware();
    const middleware = applyMiddleware(sagaMiddleware);
    let middlewareCompose;

    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === 'function') {
        middlewareCompose = compose(
            middleware,
            devToolsExtension({ trace: true })
        );
    }

    const store = createStore(rootReducer, middlewareCompose || middleware);

    setStore(store);

    sagaMiddleware.run(sagas);

    return store;
}
